// extracted by mini-css-extract-plugin
export default {"root":"PrepMaterials_root__22xT9"};